module.exports = __webpack_public_path__ + "img/model_64.2e79ccf4.jpg";